import { configureTheming } from '@tal-gel/theming';
import ThemingPluginTac from '@tal-gel/theming-plugin-tac';
configureTheming({
  plugins: [
    ThemingPluginTac,
  ]
});